import { Component, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { Subscription, filter, startWith } from 'rxjs';
import { GlobalService } from '../../../service/global.service';
import { DashboardSidebarComponent } from '../dashboard-sidebar/dashboard-sidebar.component';
import { DASHBOARD_ITEMS } from '../dashboard-menu';

@Component({
  selector: 'app-dashboard-layout',
  standalone: true,
  imports: [CommonModule, RouterModule, DashboardSidebarComponent],
  templateUrl: './dashboard-layout.component.html',
  styleUrl: './dashboard-layout.component.scss',
  // Default change detection: this component hosts the <router-outlet>, so OnPush
  // here would freeze async (HTTP) view updates inside the routed child pages.
})
export class DashboardLayoutComponent implements OnDestroy {
  pageTitle = 'Dashboard';
  drawerOpen = false;
  /** Desktop-only: collapse the sidebar to an icon rail. */
  collapsed = false;

  private readonly sub: Subscription;

  constructor(private router: Router, public gS: GlobalService) {
    this.sub = this.router.events
      .pipe(
        filter((e): e is NavigationEnd => e instanceof NavigationEnd),
        startWith(null),
      )
      .subscribe(() => {
        this.pageTitle = this.resolveTitle(this.router.url);
        this.drawerOpen = false;
      });
  }

  get initial(): string {
    return (this.gS.userName || 'U').toString().trim().charAt(0).toUpperCase();
  }

  private resolveTitle(url: string): string {
    const path = url.split('?')[0].split('#')[0].replace(/^\//, '');
    return DASHBOARD_ITEMS.find((i) => i.route === path)?.label ?? 'Dashboard';
  }

  /** One hamburger: opens the drawer on mobile, collapses the rail on desktop. */
  onBurger(): void {
    if (typeof window !== 'undefined' && window.innerWidth <= 991) {
      this.drawerOpen = !this.drawerOpen;
    } else {
      this.collapsed = !this.collapsed;
    }
  }

  closeDrawer(): void {
    this.drawerOpen = false;
  }

  logout(): void {
    this.gS.LogoutUser();
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
